// import { isEdge } from './ua'

// const isWin = isIE || isEdge
const isWin = false
const easeTransition = 'opacity 1.5s, filter 1.5s, transform 1.5s'
const easeInTransition =
  'opacity 1s ease-in, filter 1s ease-in, transform 1s ease-in'
const easeOutTransition =
  'opacity 1s ease-out, filter 1s ease-out, transform 1s ease-out'
const TRANSITION = isWin ? '' : easeTransition

const getTransition = (easing) => {
  if (easing === 'ease') {
    return TRANSITION
  } else if (easing === 'easeIn') {
    return easeInTransition
  } else if (easing === 'easeOut') {
    return easeOutTransition
  }
}

export const fadeStyle = (rate, blur = 4, opacity = 0.6, easing = 'ease') => {
  const blurResult = blur - blur * rate
  const opacityResult = opacity + rate * (1 - opacity)

  return {
    filter: `blur(${blurResult}px)`,
    opacity: opacityResult,
    transition: getTransition(easing),
    'backface-visibility': 'hidden',
    '-webkit-backface-visibility': 'hidden'
  }
}

export const blurPixel = (rate, blur = 4) => {
  const blurResult = blur - blur * rate

  return blurResult
}

export const translateStyle = (rate, { distance } = { distance: 50 }) => {
  const distanceResult = distance - rate * distance

  return {
    transition: TRANSITION,
    transform: `translateY(${distanceResult}px)`,
    'backface-visibility': 'hidden',
    '-webkit-backface-visibility': 'hidden'
  }
}

export const transformStyle = (rate, transforms, easing = 'ease') => {
  const results = []

  Object.keys(transforms).forEach((key) => {
    const value = transforms[key]

    if (key === 'x') {
      const distanceResult = value - rate * value

      results.push(`translateX(${distanceResult}px)`)
    } else if (key === 'y') {
      const distanceResult = value - rate * value

      results.push(`translateY(${distanceResult}px)`)
    } else if (key === 'scale') {
      const scaleResult = 1 + value - value * rate

      results.push(`scale(${scaleResult}) rotate(0.001deg)`)
    }
  })

  return {
    transition: getTransition(easing),
    transform: results.join(' '),
    'backface-visibility': 'hidden',
    '-webkit-backface-visibility': 'hidden'
  }
}
